// extracted by mini-css-extract-plugin
export var list = "navbar-module--list--k1wul";
export var navBar = "navbar-module--navBar--Zwiiv";